import { DonationFundsDTO } from "../dto/DonationFundsDTO";
import { DonationFund } from "../models/DonationFunds";

export const donationFundsMapper = (dto: DonationFundsDTO) => {
  return new DonationFund({
    id: dto.fundId,
    active: dto.active === "Y",
    displayOrder: dto.displayOrder,
    letterText: dto.letterText,
    showInCheckout: dto.showInCheckout === "Y",
    isEndowment: dto.isEndowment === "Y",
    portalDescription: dto.portalDescription,
    fundName: dto.fundName
  });
};
